function initialState() {
  return {
    aluno: null,
    rematricula: null,
    responsavelFinanceiro: null,
    etapaAtual: null,
    avisoVagas: true,
    alunos: []
  };
}

const mutations = {
  updateAvisoVagas(state, avisoVagas) {
    state.avisoVagas = avisoVagas;
  },
  updateResponsavelFinanceiro(state, responsavelFinanceiro) {
    state.responsavelFinanceiro = responsavelFinanceiro;
  },
  updateEtapaAtual(state, etapaAtual) {
    state.etapaAtual = etapaAtual;
  },
  updateAluno(state, aluno) {
    state.aluno = aluno;
  },
  updateAlunos(state, alunos) {
    state.alunos = alunos;
  },
  updateRematricula(state, rematricula) {
    state.rematricula = rematricula;
  },
  clearStorage(state) {
    const s = initialState();

    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  }
};

const actions = {
  resetState(state) {
    state.commit("clearStorage");
  },
  setResponsavelFinanceiro(state, responsavelFinanceiro) {
    state.commit("updateResponsavelFinanceiro", responsavelFinanceiro);
  },
  setAluno(state, aluno) {
    state.commit("updateAluno", aluno);
  },
  setEtapaAtual(state, etapaAtual) {
    state.commit("updateEtapaAtual", etapaAtual);
  },
  setAlunos(state, alunos) {
    state.commit("updateAlunos", alunos);
  },
  setRematricula(state, rematricula) {
    state.commit("updateRematricula", rematricula);
  },
  setAvisoVagas(state, avisoVagas) {
    state.commit("updateAvisoVagas", avisoVagas);
  }
};

const namespaced = true;

const rematricula = {
  namespaced,
  state: initialState(),
  actions,
  mutations
};

export default rematricula;



// WEBPACK FOOTER //
// ./src/store/rematricula.js